export const POPUP_NAMES = {
  error: 'ErrorPopup',
}

export const POPUP_MESSAGES = {
  declined: 'errors.declined',
  declined_link: 'errors.declined_link'
}
